import { NgModule } from '@angular/core';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '../app-routing.module';

@NgModule({
    declarations: [
        MainLayoutComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule
    ],
    exports: [
        MainLayoutComponent
    ]
})
export class LayoutsModule {
}
